
import {defineComponent} from "vue"
import {useRouter} from "vue-router";

export default defineComponent({
  data() {
    return {
      router: useRouter(),
      tableData: [
        {MainFeatures: "Interactive visualization", SubFeatures: "Interactive visualization", SpatialDB: '&#169;', STomicsDB: "v", SODB: "v"},
        {MainFeatures: "Regional statistics", SubFeatures: "Regional statistics", SpatialDB: '&ne', STomicsDB: "&ne;", SODB: "&ne;"},
        {MainFeatures: "Color view spatial visualization", SubFeatures: "Color view spatial visualization ", SpatialDB: '&ne;', STomicsDB: "&ne;", SODB: "&ne;"},
        {MainFeatures: "Unified data format", SubFeatures: "Unified data format", SpatialDB: '&ne;', STomicsDB: "&ne;", SODB: "&ne;"},
        {MainFeatures: "Number of units", SubFeatures: "Number of units", SpatialDB: 'N/A', STomicsDB: "N/A", SODB: "497,190,213"},
        {MainFeatures: "Number of data", SubFeatures: "Number of data", SpatialDB: '305', STomicsDB: "N/A", SODB: "2,139"},
        {MainFeatures: "Included spatial omics", SubFeatures: "Spatial Transcriptomics", SpatialDB: '8', STomicsDB: "15", SODB: "26"},
        {MainFeatures: "Included spatial omics", SubFeatures: "Spatial Proteomics", SpatialDB: '&ne;', STomicsDB: "&ne;", SODB: "&ne;"},
        {MainFeatures: "Included spatial omics", SubFeatures: "Spatial Metabolomics", SpatialDB: '&ne;', STomicsDB: "&ne;", SODB: "&ne;"},
        {MainFeatures: "Included spatial omics", SubFeatures: "Spatial Genomics", SpatialDB: '&ne;', STomicsDB: "&ne;", SODB: "&ne;"},
        {MainFeatures: "Included spatial omics", SubFeatures: "Spatial Multi-omics", SpatialDB: '&ne;', STomicsDB: "&ne;", SODB: "&ne;"},
      ]
    }
  },
  methods: {
      arraySpanMethod(table_pos:any) {
        if(table_pos.rowIndex < 6 && table_pos.columnIndex === 0)
          return {rowspan: 1, colspan: 2};
        else if(table_pos.rowIndex < 6 && table_pos.columnIndex === 1){
          return {rowspan: 0, colspan: 0};
        }
        else if(table_pos.rowIndex === 6 && table_pos.columnIndex === 0){
          return {rowspan: 5, colspan: 1};
        }
        else if(table_pos.rowIndex >= 7 && table_pos.columnIndex === 0){
          return {rowspan: 0, colspan: 0};
        }
      },
      headFirst({ row, column, rowIndex, columnIndex }: any) {
        if(rowIndex === 0){
           if(columnIndex === 0){
             if(document.getElementsByClassName(column.id).length !== 0){
               var _c = document.getElementsByClassName(column.id)
               document.getElementsByClassName(column.id)[0].setAttribute("rowSpan", "2")
              console.log(_c[0].getAttribute("rowSpan"))
             }
             return column
           }
        }
        if(rowIndex === 1){
          if(columnIndex === 0 || (columnIndex === 1)){
            return {display:"none"}
          }
        }
      }

  }
})

